import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import ProjectList from "../component/features/projects/ProjectList";
import ProjectAdd from "../component/features/projects/ProjectAdd";
import ProjectTypeSelector from "../component/features/projects/ProjectTypeSelector";
import ProjectOnboard from "../component/features/projects/ProjectOnboard";
import ProjectOnboardGuard from "../component/features/projects/ProjectOnboardGuard";
import ProjectDetail from "../component/features/projects/ProjectDetail";
import ProjectCPM from "../component/features/projects/ProjectCPM";
import ProgressCPM from "../component/features/projects/ProgressCPM";

export class ProjectRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={"/projects"} component={ProjectList} />
                <Route exact path={"/projects/select-type"} component={ProjectTypeSelector} />
                <Route exact path={"/projects/new"} component={ProjectOnboardGuard} />
                <Route exact path={"/projects/edit/:id"} component={ProjectOnboard} />
                <Route exact path={"/projects/:id/cpm"} component={ProjectCPM} />
                <Route exact path={"/projects/:id/progress"} component={ProgressCPM} />
                <Route exact path={"/projects/:id"} component={ProjectDetail} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};
